<template>
	<div id="qe_left1">
		<div class="cc-header">活动分布</div>
		<div class="main-value" id="active_dst"></div>
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgCode = storage.getItem("orgCode");
	const echarts = require("echarts");
	let activityTypeChart;
	let pageSize = 9; //echarts每页显示数量
	export default {
		data() {
			return {
				start: 0,
				end: pageSize - 1,
				total: 0
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，1小时
			let _this = this;
			setInterval(() => {
				_this.initData();
			}, 1000 * 60 * 60);
			// 定时器轮播，5秒
			setInterval(() => {
				_this.dataZoomAutoScoll();
			}, 1000 * 5);
		},
		methods: {
			//echarts图标数据过多时，x轴自动滑动
			dataZoomAutoScoll() {
				const max = this.total - 1;
				if (pageSize < this.total) {
					if (this.end > max || this.start > max - pageSize) {
						this.start = 0;
						this.end = pageSize - 1;
					} else {
						this.start += 1;
						this.end += 1;
					}
					activityTypeChart.dispatchAction({
						type: 'dataZoom',
						dataZoomIndex: 0,
						startValue: this.start,
						endValue: this.end
					});
				}
			},
			initData() {
				let _this = this;
				// 基于准备好的dom，初始化echarts实例
				activityTypeChart = echarts.init(document.getElementById("active_dst"));
				this.$http.get("/dataView/quality/edu/getActivityCount?orgCode=" + orgCode + "&termName=" + _this.$parent.$parent.$parent.termName).then(res => {
					if (res.data.code === 200) {
						_this.total = res.data.result.length;
						var xData = [];
						var yData = [];
						for (var i = 0; i < res.data.result.length; i++) {
							var obj = res.data.result[i];
							xData.push(obj.typeName);
							yData.push(obj.typeCount);
						}
						if (_this.$parent.$parent.$parent.termName == '2022-2023第二学期') {
							yData = [36, 18, 42, 23, 11];
						}
						var option = {
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'shadow'
								},
								formatter: function(params) {
									var relVal = params[0].name;
									for (var i = 0; i < params.length; i++) {
										relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '</b>个';
									}
									return relVal
								}
							},
							xAxis: {
								type: 'value',
								boundaryGap: true,
								axisLabel: {
									interval: 0,
									textStyle: {
										color: '#54beff',
										fontSize: fontSize(0.12)
									}
								},
								axisLine: {
									show: true
								},
								axisTick: {
									show: true
								},
								splitLine: {
									show: false
								}
							},
							grid: {
								x: 70,
								top: "6%",
								bottom: "16%"
							},
							yAxis: {
								type: 'category',
								data: xData,
								splitLine: {
									show: false,
									lineStyle: {
										width: 1,
										color: 'rgba(255, 255, 255, 0.2)',
									}
								},
								axisLabel: {
									textStyle: {
										color: '#54beff',
										fontSize: fontSize(0.15)
									}
								},
								axisLine: {
									show: true
								},
								axisTick: {
									show: true
								}
							},
							series: [{
								name: '活动数量',
								type: 'bar',
								data: yData,
								label: {
									normal: {
										show: true,
										position: 'right',
										offset: [5, -2],
										textStyle: {
											color: '#54beff',
											fontSize: 13
										}
									}
								},
								itemStyle: {
									//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
									normal: {
										//柱形图圆角，初始化效果
										barBorderRadius: [50],
										color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: "#2efff2" // 0% 处的颜色
										}, {
											offset: 1,
											color: "#65d1ff" // 100% 处的颜色
										}], false)
									}
								},
								barGap: '0%',
								barWidth: 12
							}]
						};
						activityTypeChart.setOption(option);
						// 响应式变化
						window.addEventListener("resize", () => activityTypeChart.resize(), false);
					}
				})
			}
		},
		destroyed() {
			window.onresize = null;
		}
	};

	function fontSize(res) {
		let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (!clientWidth) return;
		let fontSize = 100 * (clientWidth / 1920);
		return res * fontSize;
	}
</script>

<style lang="scss">
	#qe_left1 {
		height: 100%;
		padding: 0 3%;

		.cc-header {
			width: 100%;
			padding-top: 0.25rem;
			color: #55ffff;
			font-size: 0.25rem;
			padding-left: 3%;
		}

		.main-value {
			height: 85%;
			padding-left: 3%;
		}

	}
</style>